<template>
  <v-row no-gutters style="justify-content:center">
    <template v-for="skill in skills">
      <v-col cols="12" sm="3" :key="skill" style="margin:10px;">
        <v-card elevation="6">
          <v-card-title class="flexinall">
            <div>{{ skill[0] }}</div>
            <div>{{ skill[1] }}</div>
          </v-card-title>
          <v-progress-linear
            height="10"
            :value="skill[1]"
            rounded
            striped
            color="#"
            class="styledbar"
            :style="{ background: skill[2] }"
          ></v-progress-linear>
          <br />
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      skills: [
        ["React", "75%", "#ff5722"],
        ["Vue", "80%", "#4caf50"],
        ["Jquery", "70%", "#FFC107"],
        ["Jekyll", "70%", "#E57373"],
        ["Gatsby", "65%", "#303F9F"],
        ["EJS", "80%", "#1abc9c"],
      ],
    };
  },
};
</script>

<style scoped>
.styledbar {
  background: #ff5722;
  width: 90%;
  margin: auto;
}
.flexinall {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: inherit; */
}
</style>
